import * as React from "react";
import Modal from "../../ui/modal/Modal";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import JobStatus from "../../../model/job/JobStatus";

interface ComponentProps {
	/**
	 * On close action.
	 */
	onClose: () => void;
	/**
	 * On confirm action.
	 */
	onConfirm: () => void;
	/**
	 * Job status
	 */
	status: JobStatus
}

type Props = ComponentProps;

export default class ConfirmJobStatusChangeModal extends React.PureComponent<Props, {}> {
	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={"Confirm"} autoWidth={true}>
				<div style={{width: "500px"}}>
					<p className={"t-body"}>{`Are you sure you want to change all jobs statuses to: ${this.props.status.label}?`}</p>
					<ButtonTertiary label={"Cancel"} onClick={this.props.onClose}/>
					<div className={"pull-right"}>
						<ButtonPrimary label={"Process"} onClick={this.props.onConfirm}/>
					</div>
				</div>
			</Modal>
		)
	}
}